import DataURLtoFile from './DataURLtoFile'

const resizeBase64Img = async (file, params) => {
  if (!file || (file && file.isCompressed)) {
    return file
  }
  let mime_type = file.type

  if (mime_type != 'image/jpeg' && mime_type != 'image/png') {
    return file
  }

  var quality = parseInt(_.get(params, ['compressionSettings', 'quality']))
  if (isNaN(quality)) {
    quality = 100
  }
  var width = parseInt(_.get(params, ['width']))
  var height = parseInt(_.get(params, ['height']))

  let base64 = await new Promise((resolve) => {
    var reader = new FileReader()
    reader.onload = function (e) {
      resolve(e.target.result)
    }
    reader.readAsDataURL(file)
  })

  var el = document.createElement('img')
  el.setAttribute('src', base64)

  return await new Promise((resolve) => {
    el.addEventListener('load', function () {
      var canvas = document.createElement('canvas')
      var imgWidth = this.width
      if (isNaN(width)) {
        width = imgWidth
      }
      var imgHeight = this.height
      if (isNaN(height)) {
        height = imgHeight
      }

      var scale = Math.min(width / imgWidth, height / imgHeight)
      canvas.width = imgWidth * scale
      canvas.height = imgHeight * scale
      var context = canvas.getContext('2d')

      context.scale(scale, scale)

      context.drawImage(this, 0, 0)

      var newImageData = canvas.toDataURL(mime_type, quality / 100)

      let newFile = DataURLtoFile(newImageData, file.name)
      if (newFile) {
        newFile.isCompressed = true
        resolve(newFile)
      } else {
        file.isCompressed = true
        resolve(file)
      }
    })
  })
}

export default resizeBase64Img
